<template>
  <component
    :is="elementType"
    class="ux-pill"
    :class="{ 'has-link': hasLink }"
    :style="style"
  >
    <div class="pill-avatar" v-if="avatar">
      <ux-avatar :id="avatar" />
    </div>
    <template v-if="subtitle">
      {{ title
      }}<span class="font-sm font-muted">&nbsp;&bull; {{ subtitle }}</span>
    </template>
    <template v-else>
      {{ title }}
    </template>
  </component>
</template>
<script>
export default {
  props: {
    value: {},
    tag: {
      type: String,
      default: "span",
    },
    clickable: {
      type: Boolean,
    },
  },
  computed: {
    avatar() {
      const id = this.value?._id;
      if (!id) {
        return;
      }

      const isPersona = id.slice(8, 10) === "24";
      const isProfile = id.slice(8, 10) === "70";
      if (isPersona || isProfile) {
        return id;
      }
    },
    elementType() {
      return this.tag || "span";
    },
    title() {
      return [
        this.value?.title,
        this.value?.name,
        this.value?.firstName && this.value?.lastName
          ? `${this.value?.firstName} ${this.value?.lastName}`
          : this.value?.firstName,
        this.value?.firstName,
        this.value,
      ].filter(Boolean)[0];
    },
    subtitle() {
      if (this.value?.startDate) {
        if (!this.$sdk.date) {
          return;
        }

        return this.$sdk.date.readableEventDate(this.value);
      }
    },
    hasLink() {
      return this.tag === "a" || this.clickable;
    },
    style() {
      const color = this.value?.color;
      const backgroundColor = this.value?.bgColor;

      if (color || backgroundColor) {
        return {
          color,
          backgroundColor,
        };
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ux-pill {
  padding: 0.5em 0.5em;
  margin: 0.1em;
  // background: rgba(#000, 0.05);

  background: color-mix(in lab, currentColor 8%, transparent);
  color: color-mix(in lab, currentColor 70%, transparent);

  border: 1px solid transparent;
  box-sizing: border-box;
  border-radius: 0.5em;
  display: inline-block;
  line-height: 1;
  font-size: 0.7em;
  cursor: pointer;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  .pill-avatar {
    width: 2em;
    vertical-align: middle;
    display: inline-block;
    margin-right: 0.5em;
  }

  &.has-link {
    &:hover {
      border: 1px solid color-mix(in lab, currentColor 50%, transparent);
      color: color-mix(in lab, currentColor 60%, transparent);
    }
  }
}
</style>
